import { Card, CardContent } from '@repo/ui/components/card';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Crown, LogOut, Pencil } from 'lucide-react';
import { useState } from 'react';

import {
  ConfirmDialog,
  LoadingState,
  PageContainer,
} from '@/components/shared';
import { useUserMe } from '@/hooks/queries/use-user-me';
import { useAuthStore } from '@/stores/auth.store';

import { AccountHeader, AccountMenuItem } from './-components';

export const Route = createFileRoute('/(app)/account/')({
  component: AccountPage,
});

function AccountPage() {
  const navigate = useNavigate();
  const { data, isLoading } = useUserMe();
  const clearTokens = useAuthStore((state) => state.clearTokens);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const handleLogout = () => {
    clearTokens();
    navigate({ to: '/login' });
  };

  if (isLoading) {
    return (
      <PageContainer>
        <LoadingState message="Carregando..." />
      </PageContainer>
    );
  }

  const user = data?.user;

  return (
    <PageContainer>
      <div className="space-y-6">
        <AccountHeader
          name={user?.name}
          email={user?.email}
          avatarUrl={user?.avatar_url}
        />

        <Card>
          <CardContent className="p-0">
            <div className="divide-border divide-y">
              <AccountMenuItem
                icon={Crown}
                label="Meu Plano"
                to="/account/plan"
              />
              <AccountMenuItem
                icon={Pencil}
                label="Editar Perfil"
                to="/account/edit"
              />
              <AccountMenuItem
                icon={LogOut}
                label="Sair"
                onClick={() => setShowLogoutConfirm(true)}
                variant="destructive"
              />
            </div>
          </CardContent>
        </Card>
      </div>

      <ConfirmDialog
        open={showLogoutConfirm}
        onOpenChange={setShowLogoutConfirm}
        title="Sair da conta"
        description="Tem certeza que deseja sair? Você precisará fazer login novamente para acessar sua conta."
        confirmText="Sair"
        cancelText="Cancelar"
        onConfirm={handleLogout}
        variant="destructive"
      />
    </PageContainer>
  );
}
